export function getAds() {
  return fetch('/api/admin/messages');
}

export function acceptAd(externalId: string) {
  return fetch(`/api/admin/messages/${externalId}/accept`, {
    method: 'POST',
  });
}

export function rejectAd(externalId: string, reason: string) {
  const formData = new FormData();
  formData.append('reason', reason);
  return fetch(`/api/admin/messages/${externalId}/reject`, {
    body: formData,
    method: 'POST',
  });
}
